import { type Components, type Theme } from "@mui/material";

export const MuiDrawer: Components<Theme>["MuiDrawer"] = {
  defaultProps: {
    variant: "temporary",
    anchor: "right",
  },
  styleOverrides: {
    paper: {
      boxShadow: "4px 0 16px 0 rgba(0,0,0,0.30)",
    },
  },
};
